import React from "react";
import ReactDom from "react-dom";
import { Modal } from "reactstrap";
import "./MaintenancePage.css";
const MaintenancePage = ({ open, close }) => {
  if (!open) return null;
  return ReactDom.createPortal(
    <div className="modal-main main-align-center">
      <div className="modal-content-main">
        <button className="main-close" type="button" onClick={() => close()}>
          <span aria-hidden={true} className="close-btn-align">
            ×
          </span>
        </button>
        <h5 style={{ textAlign: "center" }}>
          Sorry, we're down for maintenance.
        </h5>
      </div>
    </div>,
    document.getElementById("portal")
  );
  //   return (
  //     <Modal
  //       className="modal-dialog-centered modal-lg loginModal"
  //       isOpen={open}
  //       toggle={() => close()}
  //       backdrop={false}
  //       keyboard={false}
  //     >
  //       <div className="modal-body p-4">
  //         <button
  //           aria-label="Close"
  //           className="close"
  //           data-dismiss="modal"
  //           type="button"
  //           onClick={() => close()}
  //         >
  //           <span aria-hidden={true} className="close-btn-align">
  //             ×
  //           </span>
  //         </button>
  //         <h5 style={{ textAlign: "center" }}>
  //           Sorry, we're down for maintenance.
  //         </h5>
  //         {/* <div className="btn-holder mt-3 text-center">
  //         <button
  //           onClick={this.handleLogin}
  //           className="btn btn-gradient bt-wd"
  //         >
  //           Login
  //         </button>
  //       </div>
  //       </div>
  //     </Modal>
  //   );
};

export default MaintenancePage;
